import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { PageTitle } from 'src/app/shared/app.constants';

@Component({
  selector: 'eb-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
  constructor(private activatedRoute: ActivatedRoute, private route: Router, private titleService: Title) {
    this.titleService.setTitle(PageTitle.Logout);
  }
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      const redirectUri = params['post_logout_redirect_uri'];
      if (redirectUri && this.isSafeRedirect(redirectUri)) {
        window.location.href = redirectUri;
      }
    });
  }
  login(): void {
    this.route.navigateByUrl('/');
  }

  // only allow same-origin https redirects to prevent open redirect / DOM XSS
  private isSafeRedirect(url: string): boolean {
    try {
      const parsed = new URL(url, window.location.origin);
      return parsed.protocol === 'https:' && parsed.hostname === window.location.hostname;
    } catch {
      return false;
    }
  }
}
